<div class="answer-option-code">
  {{ code }}
</div>
